import React from "react";
import {AppNavbar, DashboardCalendar, DashboardModulesTabPane, DashRecentPanel} from "../index";
import {checkNullStr, getJsonValue} from "../../common/fusion-ui/utils/ReactUtils";
import {printError, printLog} from "../utils/AppUtils";
import {useTheme} from "../../common/ProjectThemeProvider";
import {GridBox, Label, Section} from "../../common/fusion-ui";
import AppFooter from "../components/AppFooter";
import {Keys, Selectors} from "../config/AppConfig";
import {useConfig} from "../context/ConfigProvider";
import {AnimationType, FramerAnimator} from "../../common/fusion-ui/animation/FramerAnimator";
import {useToast} from "../../common/fusion-ui/provider/ToastProvider";

const AppInterface = React.memo(({
                                     label,
                                     showHome = false,
                                     labelProps = {},
                                     rootProps = {},
                                     contentWrapperProps = {},
                                     children,
                                     onDashSearchClick,
                                 }) => {
    const TAG = "AppInterface";


    const theme = useTheme();
    const {isConfigTrue, getConfig} = useConfig();
    const {showToast, changeToastVariant} = useToast();

    const animator = new FramerAnimator();

    return (<>
        <div
            {...rootProps}
            className={`w-100 m-0 p-0 position-relative ${getJsonValue(contentWrapperProps, 'className')}`}
            style={{
                backgroundColor: getJsonValue(rootProps, 'bg', theme.bgRoot),
            }}
        >
            {/*navbar*/}
            {isConfigTrue(Keys.config_showNavBar) && <AppNavbar showHome={showHome}/>}

            {/*body*/}
            <div className={`w-100 p-0 px-2 py-1x  position-relative`}
                 style={{margin: '4rem 0 0 0',}}>

                {/*<Flexbox>*/}
                {/*    {['black', 'danger', 'warning', 'info', 'success', 'primary', ''].map((item, index) => {*/}
                {/*        return <ThemedButton*/}
                {/*            className={'text-nowrap px-2 py-1'} key={index}*/}
                {/*            variant={''}*/}
                {/*            bgColor={`var(--${item})`}*/}
                {/*            hoverBgColor={`var(--${item}Dark)`}*/}
                {/*            style={{backgroundColor: item}}*/}
                {/*            color={'white'}*/}
                {/*            width={'auto'} mr={3} text={`${item} toast`}*/}
                {/*            onClick={() => toast(`This is ${item} toast!`, item)}*/}
                {/*        />*/}
                {/*    })}*/}
                {/*</Flexbox>*/}

                <GridBox className={'w-100 m-0 p-0'}
                         gap={0} sm={[12, 12]} md={[canShowRightPanels() ? 9 : 12, 3]}>
                    {/*left - children*/}
                    <div
                        className={`m-0 px-1x py-sm-1 w-100 ${(canShowTabBar() && checkNullStr(getDefTab())) ? '' : `px-3x overflow-x-hiddenx`}`}
                        style={{}}>
                        {(canShowTabBar() && checkNullStr(getDefTab())) ? <DashboardModulesTabPane
                            className={`px-3 py-2 overflow-x-hidden h-100 ${canShowTabBar() ? `py-2` : `pt-0 pb-2`}`}
                            wrapperProps={{
                                contentClassName: `px-3 py-2 overflow-x-hidden overflow-y-hidden bg-infox h-100x ${canShowTabBar() ? `py-2` : `pt-0 pb-2`}`, ...contentWrapperProps
                            }}
                            onSearchClick={onDashSearchClick}>
                            {createLabel()}
                            {children}
                        </DashboardModulesTabPane> : <Section
                            {...contentWrapperProps}
                            className={`m-0 px-3 overflow-x-hidden overflow-y-hidden mt-1x w-100 app-section height85x h-100x xh-auto ${canShowTabBar() ? `py-2` : `pt-0 pb-2`} ${getJsonValue(contentWrapperProps, 'className')}`}
                            id={Selectors.DASH_TAB_CONTENT_WRAPPER_ID}
                            bg={getJsonValue(contentWrapperProps, 'bg', theme.bg)}
                            overflow={'hidden'}
                            roundedVariant={5}
                            shadowVariant={''}
                            contentClassName={'w-100 bg-warningx h-100 py-2'}
                            style={{
                                boxShadow: getJsonValue(contentWrapperProps, 'boxShadow', theme.boxShadowMdSm),
                                minHeight: '92vh', ...getJsonValue(contentWrapperProps, 'style', {}),
                            }}
                            borderless={true}>
                            {createLabel()}
                            {children}
                        </Section>}
                    </div>

                    {/*right - calendar & recent-panel*/}
                    {canShowRightPanels() && <div className={'m-0 p-0 px-1 py-sm-1'}>
                        <div className={'m-0 p-0x ps-md-2 ps-lg-2 ps-sm-0'}>
                            {isConfigTrue(Keys.config_showCalendar) && <DashboardCalendar/>}
                            {isConfigTrue(Keys.config_showRecentPanel) && <DashRecentPanel/>}
                        </div>
                    </div>}
                </GridBox>
            </div>
        </div>
        {/*<Toast/>*/}

        {isConfigTrue(Keys.config_showFooter) && <AppFooter/>}
    </>);

    function createLabel() {
        return (checkNullStr(label)) && animator.setAnimationType(AnimationType.FADE_IN).render(<div>
            <div className={'m-0 p-0'}>
                {animator.setAnimationType(AnimationType.FADE_IN).setDelay(100).render(<Label
                    {...labelProps}
                    className={`m-0 p-0 fs-lg fw-bold my-1x mb-1 w-100 ${getJsonValue(labelProps, 'className')}`}
                    widthClass={'100'}
                    color={getJsonValue(labelProps, 'color', theme.primary)}
                    textAt={getJsonValue(labelProps, 'textAlign', 'start')}
                    style={{
                        ...getJsonValue(labelProps, 'style', {})
                    }}>
                    {label}
                </Label>)}
            </div>
        </div>)
    }

    function getDefTab() {
        return getConfig(Keys.config_TabBarTab);
    }

    function canShowTabBar() {
        return isConfigTrue(Keys.config_ShowTabBar);
    }

    function canShowRightPanels() {
        return (isConfigTrue(Keys.config_showCalendar) || isConfigTrue(Keys.config_showRecentPanel)) && isConfigTrue(Keys.config_showHomeRightPanels);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});

export default AppInterface;
